import { jsx as _jsx } from "react/jsx-runtime";
import { StoreLocatorContext, StoreLocatorMap, useStoreLocator } from "../../../../components/StoreLocator";
import { StoreLocatorProviderWrapper } from "../../../../components/StoreLocator/components/StoreLocatorProviderWrapper";
export const StoreDetailsMap = ({ store, storeIcons }) => {
    const storeLocatorData = useStoreLocator({
        defaultLat: String(store.Location.lat || 0),
        defaultLng: String(store.Location.lon || 0),
        defaultZoom: 15,
        activeStore: store,
        storeIcons: storeIcons,
    });
    return (_jsx(StoreLocatorProviderWrapper, { children: _jsx(StoreLocatorContext.Provider, { value: storeLocatorData, children: _jsx(StoreLocatorMap, {}) }) }));
};
//# sourceMappingURL=StoreDetailsMap.js.map